import React from 'react';
import { Typewriter } from 'react-simple-typewriter'
import './Header.css';
import Nasim from '../../images/nasim5.png'
import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <div className='home_container'>
            <div className='container'>
                <div className='row home_container_row align-items-center'>
                    <div className="col-lg-4">
                        <img src={Nasim} alt="Your Image" className="img-fluid" />
                    </div>
                    <div className='col-lg-8'>
                        <div className='ps-5'>
                            <h5 className='text-light'>🖐 HI THERE !</h5>
                            <h1 className='py-2 fw-bold fs-1'>
                                <span className='text-light'>I'M</span>
                                <span className='text-color ms-2'>
                                    <Typewriter
                                        words={['NASIM REZA', 'FRONT-END DEVELOPER', 'A FREELANCER', 'A WEB DESIGNER', 'A WEB DEVELOPER']}
                                        loop={true}
                                        cursor
                                        cursorStyle='_'
                                        typeSpeed={90}
                                        deleteSpeed={70}
                                        delaySpeed={1000}
                                    />
                                </span>
                            </h1>
                            <p className='fs-5 lh-lg py-3 text-secondary text-light'>I'm a Freelance UI/UX Designer and Developer based in Dhaka, Bangladesh. I strives to build immersive and beautiful web applications through carefully crafted code and user-centric design.</p>

                            <Link to='/about' class="btn special-btn  m-2" type="button">MORE ABOUT ME</Link>
                            <Link to='/portfolio' class="btn special-btn  m-2" type="button">PORTFOLIO</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;